"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'whatsapp.threads.title': 'Hilos',
    'whatsapp.threads.count': 'Total',
    'whatsapp.threads.noThreads': 'No se encontraron hilos.',
    'whatsapp.threads.noLogs': 'No hay registros de seguimiento en este hilo.',
    'whatsapp.threads.selectThread': 'Selecciona un hilo para ver sus registros.',
    'whatsapp.threads.showFinished': 'Mostrar finalizados',
    'whatsapp.threads.finished': 'Finalizado',
    'whatsapp.threads.finish': 'Finalizar',
    'whatsapp.threads.reopen': 'Reabrir',
    'whatsapp.threads.back': 'Volver',
    'whatsapp.threads.confirmFinish': '¿Marcar este hilo como finalizado?',
    'whatsapp.threads.finishFailed': 'No se pudo finalizar el hilo.',
    'whatsapp.threads.source.group': 'Grupo',
    'whatsapp.threads.source.email': 'Correo',
    'whatsapp.threads.source.dm': 'Mensaje directo',
};
